export const SHARE_LINK_ELEMENT: string = 'lombardo-share-link-element';

export function hideShareableLink() {
  const ele: HTMLElement|null = document.getElementById(SHARE_LINK_ELEMENT);
  ele?.classList.add('lombardo-hidden');
}

export function showShareableLink() {
  const ele: HTMLElement|null = document.getElementById(SHARE_LINK_ELEMENT);
  ele?.classList.remove('lombardo-hidden');
}
